/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Port } from './Port';
import {
    PortFromJSON,
    PortFromJSONTyped,
    PortToJSON,
} from './Port';

/**
 * The port array will contain 2 entries: departure and destination port. Notice the departure and arrival port may be the same port. atd is the departure time and ata is the arrival time.
 * @export
 * @interface TripHistorical
 */
export interface TripHistorical {
    /**
     * Actual Time of Departure [UTC]
     * @type {string}
     * @memberof TripHistorical
     */
    atd?: string;
    /**
     * Actual Time of Arrival [UTC]
     * @type {string}
     * @memberof TripHistorical
     */
    ata?: string;
    /**
     * 
     * @type {Array<Port>}
     * @memberof TripHistorical
     */
    port?: Array<Port>;
}

/**
 * Check if a given object implements the TripHistorical interface.
 */
export function instanceOfTripHistorical(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TripHistoricalFromJSON(json: any): TripHistorical {
    return TripHistoricalFromJSONTyped(json, false);
}

export function TripHistoricalFromJSONTyped(json: any, ignoreDiscriminator: boolean): TripHistorical {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'atd': !exists(json, 'atd') ? undefined : json['atd'],
        'ata': !exists(json, 'ata') ? undefined : json['ata'],
        'port': !exists(json, 'port') ? undefined : ((json['port'] as Array<any>).map(PortFromJSON)),
    };
}

export function TripHistoricalToJSON(value?: TripHistorical | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'atd': value.atd,
        'ata': value.ata,
        'port': value.port === undefined ? undefined : ((value.port as Array<any>).map(PortToJSON)),
    };
}

